import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { GetUserApiResponse } from '@/__generated/es-api'
import { defaultContactPermissions } from '@/app/module/contacts/definitions'
import { selectUserDetails } from '@/app/module/user/store/selectors'

export const useGetContactPermissions = () => {
  const data = useSelector(selectUserDetails) as unknown as GetUserApiResponse

  const permissions = useMemo(() => {
    if (!data) {
      return defaultContactPermissions
    }

    const orgId = data.activeOrgId
    const currentOrg = data.orgs?.find((org) => org.orgId === orgId)

    return currentOrg?.contactPermissions || defaultContactPermissions
  }, [data])

  return permissions
}
